<template>
  <div class="dialog1">
    <el-dialog :title="step === 3 ? $t('text94') : $t('text61')" :visible.sync="dialogVisible" width="30%"
      :close-on-click-modal="false" :close-on-press-escape="false" class="info-dialog" @close="onRuleClose">
      <div class="dialog-form">
        <el-form :model="formData" :rules="rules" ref="formData" class="form-data">

          <template v-if="step === 1">
            <el-form-item>
              <p style="color: #fff;font-size:16px;text-align:center;margin-bottom:10px;">
                <I18Lang id="text62" defaultText="您的初始助记词已生成，助记词为" />：
              </p>
              <p style="color: #fff;font-size:16px;text-align:center;margin-bottom:10px;">{{ userInfo.forget_pw_word }}</p>
              <p style="color: #fff;font-size:12px;line-height:18px;margin-bottom:6px;">
                <I18Lang id="text87" defaultText="请妥善保管以下助记词，它是找回帐户的的唯一凭证，请勿泄漏或遗失" />
              </p>
              <p style="color: #fff;font-size:12px;line-height:18px;margin-bottom:6px;">
                <I18Lang id="text88" defaultText="如有需要，您也可以修改为更容易记的助记词，方便日后管理和恢复帐户" />
              </p>
            </el-form-item>
          </template>

          <el-form-item v-if="step === 2" :label="$t('text63')">
            <el-input type="code" v-model="formData.forget_pw_word" :placeholder="$t('text64')"></el-input>
          </el-form-item>

          <template v-if="step === 3">
            <el-form-item>
              <p style="color: #fff;font-size:16px;text-align:center;margin-bottom:10px;">
                <I18Lang id="text91" defaultText="您的新助记词为" />: <em>{{ userInfo.forget_pw_word }}</em>
              </p>
              <p style="color: #fff;font-size:12px;text-align:center;line-height:18px;margin-bottom:6px;">
                <I18Lang id="text92" defaultText="请妥善保管您的助记词，忘记密码时可通过助记词找回帐户。" />
              </p>
              <p style="color: #fff;font-size:12px;text-align:center;line-height:18px;margin-bottom:6px;">
                <I18Lang id="text93" defaultText="请注意：若同时遗忘密码和助记词，您的帐户将无法找回。" />
              </p>
            </el-form-item>
          </template>

          <el-form-item v-if="step === 1" style="text-align: center;">
            <div class="btn kg-btn2" type="primary" @click="dialogVisible = false">
              {{ $t('my98') }}
            </div>
            <div class="btn kg-btn2" type="primary" @click="step = 2">
              {{ $t('proxymoney103') }}
            </div>
          </el-form-item>
          <el-form-item v-if="step === 2" style="text-align: center;">
            <div class="btn kg-btn2" type="primary" @click="step = 1">
              <I18Lang id="my58" defaultText="提交" />
            </div>
            <div class="btn kg-btn2" type="primary" @click="submitForm('formData')">
              <I18Lang id="user84" defaultText="提交" />
            </div>
          </el-form-item>
          <el-form-item v-if="step === 3" style="text-align: center;">
            <div class="btn kg-btn2" type="primary" @click="dialogVisible = false">
              {{ $t('my98') }}
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import i18n from '@utils/i18n'
export default {
  data () {
    return {
      step: 1,
      dialogVisible: false,
      isSubmitLoading: false,
      formData: {
        forget_pw_word: ''
      },
      rules: {
        forget_pw_word: [
          { required: true, message: i18n.t('text64'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    userInfo () {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    onRuleClose () {
      sessionStorage.setItem(`dialogMnemonicWordsVisible_${this?.userInfo?.account_id}`, '1')
    },
    init () {
      if (this.userInfo && this.userInfo.id && !this.userInfo.is_set_forget_pw && !sessionStorage.getItem(`dialogMnemonicWordsVisible_${this.userInfo.account_id}`)) {
        this.dialogVisible = true
      }
    },
    submitForm (formName) {
      this.isSubmitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          this.isSubmitLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    isValid (str) {
      return /^[A-Za-z0-9]+$/.test(str)
    },
    submit () {
      if (!this.formData.forget_pw_word) {
        this.$alert(this.$t('text64'), '', {
          confirmButtonText: this.$t('my25'),
          center: true,
          dangerouslyUseHTMLString: true,
          customClass: 'warning-alert',
          callback: (action) => { }
        })
        return
      }
      if (!this.isValid(this.formData.forget_pw_word)) {
        this.$alert(this.$t('text65'), '', {
          confirmButtonText: this.$t('my25'),
          center: true,
          dangerouslyUseHTMLString: true,
          customClass: 'warning-alert',
          callback: (action) => { }
        })
        return
      }
      this.$http
        .post('/api/user/editForgetPwWord', this.formData)
        .then((result) => {
          this.$store.dispatch('getUserInfo')
          this.step = 3
        })
        .finally(() => {
          this.isSubmitLoading = false
          this.$refs.formData.resetFields()
        })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>

<style scoped lang="scss">
.re-account-dialog {
  display: inline-block;
}

.btn-edit {
  display: inline-block;
}

::v-deep .info-dialog {
  .el-dialog {
    width: 650px !important;
    min-height: 430px;
    height: 430px;
    background: url("../../assets/img/user/short-bg.png") no-repeat center / 100% 100%;

    .el-dialog__header {
      .el-dialog__title {
        padding-top: 5px;
        text-align: left;
      }

      .el-dialog__headerbtn {
        margin-top: 8px;
      }
    }

    .el-input-group__append {
      background: transparent;
      border: 1px solid rgba(1, 178, 245, 0.5);
      border-left: none;

      button {
        cursor: pointer;
        color: #fff;
      }
    }

    .el-dialog__body {
      padding-bottom: 10px;
    }

    .form-item {
      margin-bottom: 35px;

      .form-item-label {
        font-size: 16px;
        font-weight: 400;
        color: #01b2f5;
        margin-bottom: 10px;
      }

      .form-item-value {
        font-size: 16px;
        font-family: Arial;
        font-weight: 400;
        color: rgb(#ffffff, 0.6);
      }
    }

    .input-tips {
      display: inline-block;
      padding: 0 10px;
      height: 19px;
      background: rgb(#000, 0.3);
      margin-top: 4px;
      border: none;
      border-radius: 0;
      font-size: 12px;
      font-family: Arial;
      font-weight: 400;
      color: #ffffff;
      line-height: 19px;
      text-align: center;
    }
  }
}
</style>
